import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/checkout/store/qrcode',
      name: 'qrcode',
      component: function (resolve) {
        require(['../express/qrcode'], resolve)
      }
    },
    {
      path: '/checkout/store/:store_id',
      name: 'express',
      component: function (resolve) {
        require(['../express/express'], resolve)
      }
    },
    {
      path: '/checkout/receipt/:order_id',
      name: 'receipt',
      component: function (resolve) {
        require(['../receipt/receipt'], resolve)
      }
    },
    {
      path: '/',
      name: 'index',
      component: function (resolve) {
        require(['../bolo_merchant/index'], resolve)
      }
    },
    {
      path: '/connect_me',
      name: 'connect_me',
      component: function (resolve) {
        require(['../bolo_merchant/connect_me'], resolve)
      }
    },
    {
      path: '/about_me',
      name: 'about_me',
      component: function (resolve) {
        require(['../bolo_merchant/about_us'], resolve)
      }
    },
    // Fast Pay 介绍及商务合作
    {
      path: '/fast_pay',
      name: 'fast_pay_business',
      component: function (resolve) {
        require(['../fast_pay_business/fast_pay_business'], resolve)
      }
    },
    {
      path: '/fast_pay/connect_us',
      name: 'fast_pay_connect_us',
      component: function (resolve) {
        require(['../fast_pay_business/fast_pay_connect_us'], resolve)
      }
    },
    {
      path: '/fast_pay/about_us',
      name: 'fast_pay_about_us',
      component: function (resolve) {
        require(['../fast_pay_business/about_us'], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/_router/index.js